// T5: honesty marker for a timeline tile whose FY bucket(s) at the window edge hold only part
// of a fiscal year while carrying the full-FY label (e.g. an FY-YTD or "last 12 weeks" window).
// Mirrors CoarseningMarker's idiom exactly (Chip + Tooltip, tabIndex for keyboard reach, and an
// aria-label carrying the full reason — the glyph + colour alone is not accessible).
import { Chip, Tooltip } from '@mui/material'
import { GRANULARITY } from '~/components/Charts/chrome/chartChrome'

/** `labels` are the FY labels (e.g. "FY 24/25") of the buckets the current window leaves
 *  partial — renders nothing when the list is empty (fully-covered window, or a non-fy unit). */
export function PartialFyNote({ labels }: { labels: string[] }) {
  if (labels.length === 0) return null
  const note = GRANULARITY.partialFyNote(labels)
  return (
    <Tooltip title={note}>
      <Chip
        size="small"
        color="warning"
        variant="outlined"
        label={GRANULARITY.partialFyMarker}
        // tabIndex makes the Tooltip reachable by keyboard; aria-label gives screen
        // readers the full reason (the marker glyph + colour alone are not accessible).
        tabIndex={0}
        aria-label={note}
      />
    </Tooltip>
  )
}
